var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInvoice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 256 256"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 128a8 8 0 010-16h28a8 8 0 000-16H40a24 24 0 010-48 8 8 0 0116 0h8a8 8 0 010 16H40a8 8 0 000 16h16a24 24 0 010 48 8 8 0 01-16 0zm196-80H96a8 8 0 000 16h120v32H104a8 8 0 000 16h56v32H80a8 8 0 000 16h80v32H40v-40a8 8 0 00-16 0v40a16 16 0 0016 16h176a16 16 0 0016-16V56a8 8 0 00-8-8z"
  })));
}

export default SvgInvoice;